import React from 'react';
import {connect} from 'react-redux';
import Moment from 'moment';
import {browserHistory} from 'react-router';

import {getCenter, getAngleFromCoords, getDistanceBetweenPoints} from '../../utils/Coordinates.js';
import {completeMeditation, startMeditation, progressMeditation, playMeditation, pauseMeditation} from '../../actions/Meditation';
import {getUserStatsAction} from '../../actions/User';
import {getPackageMeditations} from '../../actions/Package';

import PackageProgress from '../Presentation/PackageProgress';
import Loader from '../Presentation/Loader';

import {openFeedbackPopup} from '../../actions/Popup';
import {getMeditations} from '../../actions/Meditation';

import DocumentTitle from 'react-document-title';
import buildTitle from '../../utils/TitleBuilder';

class PlayScreen extends React.Component {
    constructor(props) {
        super(props);

        this.goBack = this.goBack.bind(this);
        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);
        this.seek = this.seek.bind(this);
        this.startSeeking = this.startSeeking.bind(this);
        this.stopSeeking = this.stopSeeking.bind(this);
        this.getMeditation = this.getMeditation.bind(this);
        this.next = this.next.bind(this);
        this.prev = this.prev.bind(this);
        this.saveProgress = this.saveProgress.bind(this);
        this.start = this.start.bind(this);
        this.complete = this.complete.bind(this);

        this.state = {
            seeking: false,
            playing: false,
            currentTime: 0,
            lastSavedProgress: 0,
            currentMeditation: 0
        };

    }

    goBack() {
        browserHistory.goBack();
    }

    refreshMeditations() {
        return this.props.dispatch(getMeditations(this.refreshMeditations));
    }

    start() {
        const med = this.getMeditation();
        this.props.dispatch(startMeditation(this.start, med.id))
            .then(data => {
                this.refreshMeditations();
                return data;
            });
    }

    saveProgress() {
        const med = this.getMeditation();
        if (med.userMeditationId && !med.completed) {
            this.props.dispatch(progressMeditation(this.saveProgress, {
                id: med.userMeditationId,
                progress: this.state.currentTime
            }))
                .then(data => {
                    this.refreshMeditations();
                    return data;
                });
        }
    }

    complete() {
        const med = this.getMeditation();
        // if (med && !med.completed) {
        if (med) {
            let medAlreadyCompleted = med.completed;

            this.props.dispatch(completeMeditation(this.complete, med.userMeditationId))
                .then(data => {
                    this.refreshMeditations()
                        .then(() => {
                            if(this.refs.player) {
                                this.refs.player.currentTime = 0;
                            }
                        });
                    this.props.dispatch(openFeedbackPopup({
                        id: med.userMeditationId,
                        packTitle: this.props.pack.title,
                        packCompleted: (this.props.pack.meditationsCount === med.position),
                        completedMeditation: med.position,
                        medAlreadyCompleted: medAlreadyCompleted
                    }));

                    browserHistory.push('/');

                    return data;
                })
                .then(data => {
                    this.updateUserStats();
                });
        }
        this.pause();
    }

    updateUserStats() {
        this.props.dispatch(getUserStatsAction(this.updateUserStats, 'me'))
    }

    play(updateState = true) {
        if (this.refs.player) {

            this.refs.player.play();


            if (updateState) {
                const med = this.getMeditation();

                this.props.dispatch(playMeditation({
                    meditation: med,
                    userId: this.props.user.id
                }));

                let hasStarted = false;

                if (med) {
                    hasStarted = med.createdAt;
                }

                if (!hasStarted) {
                    this.start();
                }

                this.setState({
                    playing: true
                })
            }
        }
    }

    pause(updateState = true) {
        if (this.refs.player) {


            this.refs.player.pause();

            if (updateState) {

                const med = this.getMeditation();
                this.props.dispatch(pauseMeditation({
                    meditation: med,
                    userId: this.props.user.id
                }));

                this.setState({
                    playing: false
                })
            }
        }
    }

    startSeeking() {
        this.setState({seeking: true});
        this.pause(false);
    }

    stopSeeking(e) {
        if (this.state.seeking) {
            this.seek(e);
            this.setState({seeking: false});
            if (this.state.playing) {
                this.play(false);
            }
        }
    }

    seek(e) {
        if (this.state.seeking && this.refs.player && this.refs.seeker) {
            const seeker = this.refs.seeker;
            const meditation = this.getMeditation();
            const {duration} = meditation;

            const targetPoint = {
                x: e.pageX,
                y: e.pageY
            };

            const center = getCenter(seeker);

            if (getDistanceBetweenPoints(center, targetPoint) > 75) { //TODO dont leave this hardcoded
                const angle = getAngleFromCoords(center, targetPoint);
                const seconds = duration * angle / 360;
                if (this.refs.player) {
                    this.refs.player.currentTime = seconds;
                }
            }
        }
    }

    getPercentProgress() {
        const meditation = this.getMeditation();
        if (meditation) {
            const {duration} = meditation;
            const {currentTime} = this.state;
            return Math.floor(currentTime / duration * 100);
        }
        else {
            return 0;
        }
    }

    getMeditation() {
        const {pack} = this.props;

        if (this.state.currentMeditation) {
            if (pack.meditations.length) {
                return pack.meditations.find(m => m.position === this.state.currentMeditation)
            }
            else {
                return false;
            }
        }

        else {
            if (pack && pack.meditations) {
                if (pack.meditations.length) {
                    for (let i = 0; i < pack.meditations.length; i++) {
                        let med = pack.meditations[i];
                        if (med.completed) {
                            if (i === pack.meditations.length - 1) {
                                //
                            }
                            else {
                                continue;
                            }
                        }

                        this.setState({
                            currentMeditation: med.position
                        });

                        return med;
                    }
                }
                else {
                    if (pack.meditations.length) {
                        let med = pack.meditations.find(m => m.position === 1);

                        if(med) {
                            this.setState({
                                currentMeditation: 1
                            })
                        }

                        return med;
                    }
                    else {
                        return false;
                    }
                }
            }
        }

        return false;
    }

    next() {
        this.pause();
        this.setState({
            currentMeditation: this.state.currentMeditation + 1
        });
    }

    prev() {
        this.pause();
        this.setState({
            currentMeditation: this.state.currentMeditation - 1
        });
    }

    getData(newProps) {
        const justFinishedLoading = this.props && !this.props.loadingDone && newProps && newProps.loadingDone;
        const loadedButMeditationsNotFetched = this.props && this.props.pack && this.props.loadingDone
            && !this.props.pack.meditationsPending && !this.props.pack.meditationsFetched;

        if (justFinishedLoading || loadedButMeditationsNotFetched) {
            this.dispatchGetPackMeditations(this.props.routeParams.id);
        }
        else {
            this.setSavedProgress();
        }
    }

    dispatchGetPackMeditations(id) {
        this.props.dispatch(getPackageMeditations(this.dispatchGetPackMeditations.bind(this, id), id))
            .then(() => {
                this.setSavedProgress();
            });
    }

    setSavedProgress() {
        const med = this.getMeditation();
        const progress = this.state.lastSavedProgress || med.progress;
        if (progress && this.refs.player && med.progress < med.duration) {
            this.refs.player.currentTime = progress;
        }
    }

    componentDidMount() {
        if (this.refs.player) {
            this.refs.player.addEventListener("timeupdate", () => {
                if (this.refs.player) {
                    const currentTime = this.refs.player.currentTime;
                    let newState = {currentTime};
                    if (this.state.playing && currentTime - this.state.lastSavedProgress > 10) {
                        // TODO there is an issue when seeking -> find a solution
                        newState.lastSavedProgress = currentTime;
                        this.saveProgress();
                    }
                    this.setState(newState);
                }
            });
        }

        this.getData();
    };

    componentWillReceiveProps(newProps) {
        this.getData(newProps);
    }

    render() {
        const {userMeditationsPending, packagePending, pack, user} = this.props;
        const {currentTime} = this.state;

        const med = this.getMeditation();
        const showLoading = userMeditationsPending || packagePending || !med;


        const duration = med ? med.duration : 0;
        const durationMinutes = Math.round((duration) / 60);
        const percentProgress = this.getPercentProgress();
        const progressClassName = `current-set p-${percentProgress}`;

        let btnClass = "play-btn";
        let btnHandler = this.play;

        if (this.state.playing) {
            btnClass = "pause-btn";
            btnHandler = this.pause;
        }

        const prevDisabled = med.position <= 1;
        const nextDisabled = !(pack && pack.meditations.length && pack.meditations.find( m => m.position === med.position + 1) && med.completed);
        const title = pack ? [`Ден ${ med ? med.position : 1 } от ${pack.meditationsCount}`, pack.title] : null;

        return <DocumentTitle title={buildTitle(title)}>
            <div>
                <Loader show={showLoading}/>
                <div className={showLoading ? "play-screen loading" : "play-screen"} onMouseMove={this.seek}
                     onMouseUp={this.stopSeeking}>
                    <button type="button" id="close-play-screen" className="close-btn" onClick={this.goBack}/>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <audio className="hidden" ref="player" src={med.audioUrl} onEnded={this.complete}/>
                                <div className="meditation-title">
                                    <button onClick={this.prev} className="arrow arrow-left" disabled={prevDisabled} />
                                    <div>
                                        <h2>{med.title}</h2>
                                        <div className="meditation-time">
                                            <span>{durationMinutes}</span> {durationMinutes === 1 ? 'минута' : 'минути'}
                                        </div>
                                    </div>
                                    <button onClick={this.next} className="arrow arrow-right" disabled={nextDisabled} />
                                </div>
                                <div className={progressClassName} ref="seeker" onMouseDown={this.startSeeking}>
                                    <div className="inner">
                                        <button className={btnClass} onClick={btnHandler}/>
                                    </div>
                                    {pack ? <PackageProgress total={pack.meditationsCount} current={med.position}/> : null }
                                </div>
                                <div className="duration">{Moment.utc(currentTime * 1000).format('mm:ss')}</div>
                            </div>
                        </div>
                        <div className="user-id hidden">{user.id}</div>
                    </div>
                </div>
            </div>
        </DocumentTitle>
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        pack: state.packages.packages.find(p => p.id === parseInt(ownProps.routeParams.id)),
        userMeditationsPending: state.packages.userMeditationsPending,
        packagePending: state.packages.packagesPending,
        loadingDone: state.util.loadingDone,
        user: state.user.userData
    }
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayScreen);


// WEBPACK FOOTER //
// ./src/components/Pages/PlayScreen.js